export default function sortBySectionCompletion(list) {
    return list.sort((a, b) => {
        const percentageA = a.completed_students / a.total_students
        const percentageB = b.completed_students / b.total_students
        return percentageB - percentageA
    });
}
